import React from "react";
import { useAuth } from "@/contexts/AuthContext";

// Real SVG flag — Windows does not render the 🇺🇸 emoji (it shows "US").
export function UsFlagIcon({ className = "h-4", title = "Ship to USA", ...rest }) {
  return (
    <svg viewBox="0 0 19 10" className={`inline-block w-auto rounded-[1px] shadow-sm ring-1 ring-black/10 ${className}`} role="img" aria-label={title} {...rest}>
      <title>{title}</title>
      <rect width="19" height="10" fill="#fff" />
      {[0, 2, 4, 6, 8].map((y) => <rect key={y} y={y} width="19" height="1" fill="#B22234" />)}
      <rect y="9" width="19" height="1" fill="#B22234" />
      <rect width="7.6" height="5.4" fill="#3C3B6E" />
      {[0.9, 2.1, 3.3, 4.5].map((cy) =>
        [0.8, 2.0, 3.2, 4.4, 5.6, 6.8].map((cx) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="0.28" fill="#fff" />
        ))
      )}
    </svg>
  );
}

// Auto-detects a US destination; `us_flag_override` (set by Back Office /
// Super Admin) wins over the address when present. Orders whose cover
// color is "Custom Color" or "Light Cyan" never show the flag automatically.
const NO_FLAG_COLORS = ["custom color", "custom", "light cyan", "lt. cyan", "lt.cyan"];

export function isUsOrder(order) {
  if (order?.us_flag_override === true) return true;
  if (order?.us_flag_override === false) return false;
  const color = String(order?.color || "").trim().toLowerCase();
  if (NO_FLAG_COLORS.includes(color) || color.includes("custom")) return false;
  const c = String(order?.shipping_address?.country || "").trim().toUpperCase();
  return c === "US" || c === "USA" || c === "UNITED STATES" || c === "UNITED STATES OF AMERICA";
}

const SIZES = { sm: "h-3", md: "h-4", lg: "h-7" };

// Factory One staff never see the flag — only the Factory One Administrator does.
export function canSeeUsFlag(user) {
  if (user?.role === "factory_1" && user?.sub_role !== "administrator") return false;
  return true;
}

export function UsFlag({ order, testid, size = "md" }) {
  const { user } = useAuth();
  if (!canSeeUsFlag(user)) return null;
  if (!isUsOrder(order)) return null;
  return (
    <span className="inline-flex items-center leading-none" title="Ship to USA" data-testid={testid || `us-flag-${order?.id}`}>
      <UsFlagIcon className={SIZES[size] || SIZES.md} />
    </span>
  );
}
